window.tinyMCE.PluginManager.add('customhf', function (editor) {
  const headerIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<line x1="3" y1="5" x2="21" y2="5" stroke="black" stroke-width="1" stroke-dasharray="4,4"/>' +
    '<line x1="3" y1="9" x2="21" y2="9" stroke="black" stroke-width="2"/>' +
    '<line x1="3" y1="13" x2="21" y2="13" stroke="black" stroke-width="2"/>' +
    '<line x1="3" y1="17" x2="21" y2="17" stroke="black" stroke-width="2"/>' +
    '</svg>';

  editor.ui.registry.addIcon('customHeader', headerIcon);

  // Add the header button
  editor.ui.registry.addButton('customheader', {
    icon: 'customHeader', // Use the customHeader icon
    tooltip: 'Insert Header',
    onAction: function () {
      editor.windowManager.open({
        title: 'Insert Header',
        body: {
          type: 'panel',
          items: [
            {
              type: 'input',
              name: 'headerContent',
              label: 'Header Content'
            },
            {
              type: 'colorinput',
              name: 'headerBackgroundColor',
              label: 'Background Color'
            },
            {
              type: 'colorinput',
              name: 'headerTextColor',
              label: 'Text Color'
            }
          ]
        },
        buttons: [
          {
            text: 'Insert',
            type: 'submit',
            primary: true
          },
          {
            text: 'Cancel',
            type: 'cancel'
          }
        ],
        onSubmit: function (api) {
          const data = api.getData();
          const headerStyle = `background-color: ${data.headerBackgroundColor || '#fff'}; color: ${
            data.headerTextColor || '#000'
          }; padding: 10px; text-align: center;`;
          const headerContent = `<div style="${headerStyle}">${
            data.headerContent || 'Header'
          }</div>`;
          editor.insertContent(headerContent);
          api.close();
        }
      });
    }
  });

  // Add the footer button
  const footerIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<line x1="3" y1="5" x2="21" y2="5" stroke="black" stroke-width="2"/>' +
    '<line x1="3" y1="9" x2="21" y2="9" stroke="black" stroke-width="2"/>' +
    '<line x1="3" y1="13" x2="21" y2="13" stroke="black" stroke-width="2"/>' +
    '<line x1="3" y1="17" x2="21" y2="17" stroke="black" stroke-width="1" stroke-dasharray="4,4"/>' +
    '</svg>';

  editor.ui.registry.addIcon('customFooter', footerIcon);

  editor.ui.registry.addButton('customfooter', {
    icon: 'customFooter', // Use the customFooter icon
    tooltip: 'Insert Footer', // Set the tooltip for the button
    onAction: function () {
      editor.windowManager.open({
        title: 'Insert Footer',
        body: {
          type: 'panel',
          items: [
            {
              type: 'input',
              name: 'footerContent',
              label: 'Footer Content'
            },
            {
              type: 'colorinput',
              name: 'footerBackgroundColor',
              label: 'Background Color'
            },
            {
              type: 'colorinput',
              name: 'footerTextColor',
              label: 'Text Color'
            }
          ]
        },
        buttons: [
          {
            text: 'Insert',
            type: 'submit',
            primary: true
          },
          {
            text: 'Cancel',
            type: 'cancel'
          }
        ],
        onSubmit: function (api) {
          const data = api.getData();
          const footerStyle = `background-color: ${data.footerBackgroundColor || '#fff'}; color: ${
            data.footerTextColor || '#000'
          }; padding: 10px; text-align: center;`;
          const footerContent = `<div style="${footerStyle}">${
            data.footerContent || 'Footer'
          }</div>`;
          editor.insertContent(footerContent);
          api.close();
        }
      });
    }
  });
});
